import { filters } from './filters'
import { toolbars } from './toolbars'
import { location } from './locationLoader'
import { media } from './media'
import { features } from './features'
import { visualizer } from './visualizer'
import { collaborativeIndexation } from './collaborativeIndexation'
import { shareActions } from './share'

export const configuration = {
    toolbars,
    filters,
    location,
    media,
    features,
    visualizer,
    collaborativeIndexation,
    share: shareActions,
}
